import { useMemo } from 'react'
import PropTypes from 'prop-types'
import TopNav from './TopNav'
import SideNav from './SideNav'
import { checkScope } from '~/lib/helpers/checkScope'
import useToggle from '~/hooks/useToggle'

function HeaderPublic ({ url, headerClass }) {
  return (
    <header className={headerClass}>
      <TopNav
        url={url}
        publicAccess
      />
    </header>
  )
}

function HeaderAuthenticated ({ url, headerClass, profile, toggleSearchModal, toggleQuickLinksModal }) {
  const [sidenavOpen, toggleSideNav] = useToggle()
  const admin = useMemo(() => checkScope(profile, 'admin.*'))
  const provider = useMemo(() => checkScope(profile, 'profile.provider.view'))

  return (
    <header className={headerClass}>
      <TopNav
        url={url}
        profile={profile}
        admin={admin}
        provider={provider}
        toggleSideNav={toggleSideNav}
        toggleSearchModal={toggleSearchModal}
        toggleQuickLinksModal={toggleQuickLinksModal}
        publicAccess={false}
      />
      <SideNav
        profile={profile}
        provider={provider}
        sidenavOpen={sidenavOpen}
        toggleSideNav={toggleSideNav}
      />
    </header>
  )
}

function Header ({ url, publicAccess, profile, toggleSearchModal, toggleQuickLinksModal }) {
  let headerClass = ''

  // If not in production, use either dev or staging header
  if (!process.env.CI_COMMIT_REF_NAME) {
    headerClass = 'dev-header'
  } else if (process.env.CI_COMMIT_REF_NAME !== 'master') {
    headerClass = 'staging-header'
  }

  if (publicAccess) {
    return (
      <HeaderPublic url={url} headerClass={headerClass} />
    )
  } else {
    return (
      <HeaderAuthenticated
        url={url}
        headerClass={headerClass}
        profile={profile}
        toggleSearchModal={toggleSearchModal}
        toggleQuickLinksModal={toggleQuickLinksModal}
      />
    )
  }
}

Header.propTypes = {
  url: PropTypes.object,
  publicAccess: PropTypes.bool.isRequired,
  profile: PropTypes.object,
  toggleSearchModal: PropTypes.func,
  toggleQuickLinksModal: PropTypes.func
}

export default Header
